// src/services/bettingService.js
import { fetchWithAuth } from './authFetch'

const API_BASE_URL = `${process.env.VUE_APP_API_BASE_URL}/betting`;

async function fetchFromApi(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  const defaultHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Token ${localStorage.getItem('userToken')}`
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  };

  try {
    const response = await fetchWithAuth(url, config);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Erro desconhecido');
    }
    // If the response status is 204 (No Content), return null
    if (response.status === 204) {
      return null;
    }
    return await response.json();
  } catch (error) {
    console.error('Erro ao fazer requisição para a API:', error);
    throw error;
  }
}

export function createBettingAccount(data) {
  return fetchFromApi('/accounts/', {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function updateBettingAccount(accountId, data) {
  return fetchFromApi(`/accounts/${accountId}/`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
}

export function deleteBettingAccount(accountId) {
  return fetchFromApi(`/accounts/${accountId}/`, {
    method: 'DELETE'
  });
}

export function createAccountBalance(data) {
  console.log('Sending data to createAccountBalance:', data); // Log para verificar os dados enviados
  return fetchFromApi('/balance/', {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function deleteAccountBalance(balanceId) {
  return fetchFromApi(`/balance/${balanceId}/`, {
    method: 'DELETE'
  });
}

export function getDailySummary(userId, month, year) {
  return fetchFromApi(`/accounts/daily-summary/${userId}/?month=${month}&year=${year}`);
}

export function getMonthlyWithdrawals(userId, year) {
  return fetchFromApi(`/accounts/monthly-withdrawals/${userId}/?year=${year}`);
}

export function getAnnualDeposits(userId, year) {
  return fetchFromApi(`/accounts/annual-deposits-total/${userId}/?year=${year}`);
}

export function getUserBalanceRanking() {
  return fetchFromApi(`/accounts/user-balance-ranking/`);
}

export function getAccountBalances(accountId) {
  return fetchFromApi(`/accounts/${accountId}/`);
}

export function createWithdraw(accountId, data) {
  return fetchFromApi(`/betting/withdraw/account/${accountId}/`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function deleteWithdraw(withdrawId) {
  return fetchFromApi(`/betting/withdraw/${withdrawId}/`, {
    method: 'DELETE'
  });
}

export function getAccountWithdraws(accountId) {
  return fetchFromApi(`/accounts/${accountId}/`);
}

export function getActiveAccountsBalance() {
  return fetchFromApi('/active-accounts-balance/');
}

export function getBettingAccounts() {
  return fetchFromApi('/accounts/');
}

export function createDeposit(data) {
  return fetchFromApi('/deposit/', {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function deleteDeposit(depositId) {
  return fetchFromApi(`/deposit/${depositId}/`, {
    method: 'DELETE'
  });
}

export function createAccountDeposit(data) {
  return fetchFromApi('/deposits/', {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function createAccountWithdraw(data) {
  return fetchFromApi('/withdrawals/', {
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function getAccountTransactions() {
  return fetchFromApi('/transactions/');
}